import f from "i18next";
import A from "../data/mock.js";
const h = ["VAT", "VATWithDiscount", "periodVATWithDiscount"], p = ["totalVAT", "periodTotalVAT"], a = (t, i) => t * i / 100, T = (t) => t ? typeof t == "number" ? t : typeof t == "string" ? parseFloat(t.replaceAll(",", ".").replace(/[^0-9.]/g, "") || "0") : 0 : 0, I = (t, i, e) => {
  var o;
  const { t: n } = f, s = (o = A.productTableColumns.find((u) => t === u.id)) == null ? void 0 : o.type, r = T(i);
  return !i && h.includes(t) ? n("uikit:without_vat") : s === "percentage" ? new Intl.NumberFormat(e, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(r) + " %" : new Intl.NumberFormat(e, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(r);
}, W = (t, i, e) => {
  var o;
  const { t: n } = f, s = (o = A.productTableFooter.find((u) => t === u.id)) == null ? void 0 : o.type, r = T(i);
  return !i && p.includes(t) ? n("uikit:without_vat") : s === "percentage" ? new Intl.NumberFormat(e, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(r) + " %" : new Intl.NumberFormat(e, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(r) + "";
}, c = {
  price: ({ price: t }) => t,
  VAT: ({ VAT: t }) => t,
  count: ({ count: t }) => t,
  discountPercent: ({ discountPercent: t }) => t,
  discountCost: ({ discountCost: t }) => t,
  VATWithDiscount: (t, i) => t.VAT ? c.priceItemsWithDiscount(t, i) / (100 + t.VAT) * t.VAT : 0,
  priceWithDiscount: ({ price: t, discountPercent: i, discountCost: e }) => e ? t - e : a(t, 100 - i),
  priceItemsWithDiscount: ({ price: t, count: i, discountPercent: e, discountCost: n }) => n ? (t - n) * i : e ? a(t * i, 100 - e) : t * i,
  priceItemsWithDiscountAndVAT: (t, i) => c.priceItemsWithDiscount(t, i) + c.VATWithDiscount(t, i),
  markdownNewPrice: ({ markdownNewPrice: t }) => t,
  markdownCount: ({ markdownCount: t }) => t,
  markdownNewPriceItemsWithDiscount: ({ markdownNewPrice: t, markdownCount: i }) => t * i,
  markdownAmount: (t, i) => c.priceItemsWithDiscount(t, i) - c.markdownNewPriceItemsWithDiscount(t, i),
  // ks-3
  periodPrice: ({ periodPrice: t }) => t,
  periodVATWithDiscount: (t, i) => t.VAT ? i ? c.periodPriceItemsWithDiscount(t, i) / (100 + t.VAT) * t.VAT : c.periodPriceItemsWithDiscount(t, i) * t.VAT / 100 : 0,
  periodPriceItemsWithDiscount: ({ periodPrice: t, count: i, discountPercent: e, discountCost: n }) => n ? (t - n) * i : e ? a(t * i, 100 - e) : t * i
}, l = {
  totalCountItems: (t) => t.length,
  totalDiscountCost: (t, { totalDiscountCost: i }) => i,
  totalDiscountPercent: (t, { totalDiscountPercent: i }) => i,
  totalDicountCostItem: (t, i, e) => {
    const n = t.reduce((r, { count: o }) => r + o, 0);
    if (i.totalDiscountCost)
      return i.totalDiscountCost / n;
    if (!i.totalDiscountPercent)
      return 0;
    let s = t.reduce((r, o) => r + c.priceItemsWithDiscount(o, e), 0);
    if (!e) {
      const r = l.totalVAT(t, i, e);
      s += r;
    }
    return a(s, i.totalDiscountPercent) / n;
  },
  totalVAT: (t, i, e) => {
    const n = t.reduce((r, { count: o }) => r + o, 0);
    return t.reduce((r, o) => {
      if (!o.VAT)
        return r;
      if (i.totalDiscountCost) {
        const m = c.priceItemsWithDiscount(o, e) - i.totalDiscountCost / n * o.count;
        return r + a(m, o.VAT);
      }
      if (i.totalDiscountPercent) {
        const u = c.priceItemsWithDiscount(o, e), m = a(u, 100 - i.totalDiscountPercent);
        return r + a(m, o.VAT);
      }
      return r + c.VATWithDiscount(o, e);
    }, 0);
  },
  totalPrice: (t, i, e) => {
    let n = t.reduce((s, r) => s + c.priceItemsWithDiscount(r, e), 0);
    if (i.totalDiscountCost ? n -= i.totalDiscountCost : i.totalDiscountPercent && (n = a(n, 100 - i.totalDiscountPercent)), !e) {
      const s = l.totalVAT(t, i, e);
      n += s;
    }
    return n;
  },
  totalPriceWithDiscountAndVAT: (t, i, e) => t.reduce((n, s) => n + c.priceItemsWithDiscountAndVAT(s, e), 0),
  // ks-3
  periodTotalDicountCostItem: (t, i, e) => {
    const n = t.reduce((o, { count: u }) => o + u, 0);
    if (i.totalDiscountCost)
      return i.totalDiscountCost / n;
    if (!i.totalDiscountPercent)
      return 0;
    const s = l.periodTotalPrice(t, i, e);
    return a(s, i.totalDiscountPercent) / n;
  },
  periodTotalVAT: (t, i, e) => {
    const n = t.reduce((r, { count: o }) => r + o, 0);
    return t.reduce((r, o) => {
      if (!o.VAT)
        return r;
      if (i.totalDiscountCost) {
        const m = c.periodPriceItemsWithDiscount(o, e) - i.totalDiscountCost / n * o.count;
        return r + a(m, o.VAT);
      }
      if (i.totalDiscountPercent) {
        const u = c.periodPriceItemsWithDiscount(o, e), m = a(u, 100 - i.totalDiscountPercent);
        return r + a(m, o.VAT);
      }
      return r + c.periodVATWithDiscount(o, e);
    }, 0);
  },
  periodTotalPrice: (t, i, e) => {
    let n = t.reduce((s, r) => s + c.periodPriceItemsWithDiscount(r, e), 0);
    if (i.totalDiscountCost ? n -= i.totalDiscountCost : i.totalDiscountPercent && (n = a(n, 100 - i.totalDiscountPercent)), !e) {
      const s = l.periodTotalVAT(t, i, e);
      n += s;
    }
    return n;
  },
  periodTotalPriceWithoutVAT: (t, i, e) => {
    let n = t.reduce((s, r) => s + c.periodPriceItemsWithDiscount(r, e), 0);
    if (i.totalDiscountCost ? n -= i.totalDiscountCost : i.totalDiscountPercent && (n = a(n, 100 - i.totalDiscountPercent)), e) {
      const s = l.periodTotalVAT(t, i, e);
      n -= s;
    }
    return n;
  }
}, b = (t, i, e) => {
  const n = Object.entries(t).reduce((r, [o, u]) => c[o] ? { ...r, [o]: T(u) } : r, {}), s = Object.keys(n).reduce((r, o) => {
    if (o === "count" || o === "markdownCount")
      return r;
    const u = c[o](n, e);
    return { ...r, [o]: I(o, u, i) };
  }, {});
  return { ...t, ...s };
}, w = (t, i, e, n) => {
  const s = t.filter(({ type: u }) => u !== "title").map((u) => Object.entries(u).reduce((m, [D, V]) => c[D] ? { ...m, [D]: T(V) } : m, {})), r = Object.entries(i).reduce((u, [m, D]) => l[m] ? { ...u, [m]: T(D) } : u, {}), o = Object.keys(r).reduce((u, m) => {
    const D = l[m](s, r, n);
    return { ...u, [m]: W(m, D, e) };
  }, {});
  return { ...i, ...o };
}, d = (t) => {
  let i = 1;
  return t.map((e) => {
    if (!e.number)
      return i = 1, e;
    const n = i + "";
    return i++, { ...e, number: n };
  });
};
export {
  h as PRODUCT_VAT_IDS,
  p as TOTAL_VAT_IDS,
  b as calculateProductValues,
  w as calculateTotalValues,
  d as recalculateNumbers
};
